const doc = [({"en":({"js":({"bank_accounts":({"account_type_select":({"choose_account_type":"Choose account type"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;